export default "__VITE_ASSET__CKFp8Qet__"